import { Capacitor } from '@capacitor/core'
import { Device } from '@capacitor/device'

import { logger, rum } from '@/monitoring'
import { getUpdater } from '@/updater'

import type { Device as DeviceType } from '../types/device'
import { isElectron } from './device-type'

export async function getDeviceInfo(): Promise<DeviceType> {
  const deviceInfo = await Device.getInfo()
  const updater = getUpdater()
  const version = await updater.getVersion()
  const isNew = !window.localStorage.getItem('_capuid')
  let deviceId = await Device.getId().then(res => res.identifier)
  let deviceName = deviceInfo.name ?? undefined
  if (isElectron) {
    try {
      const ipcRenderer = window.require('electron').ipcRenderer
      const savedDeviceId = await ipcRenderer.invoke('deviceId', deviceId)
      if (isNew && savedDeviceId !== deviceId) {
        deviceId = savedDeviceId
        window.localStorage.setItem('_capuid', deviceId)
        logger.info(`Device reinstall detected`, { deviceId })
      }
      deviceName = await ipcRenderer.invoke('deviceName')
    } catch (e) {
      rum.addError(e)
    }
  }

  return {
    id: deviceId,
    name: deviceName,
    platform: Capacitor.getPlatform(),
    model: deviceInfo.model,
    os: deviceInfo.operatingSystem,
    osVersion: deviceInfo.osVersion,
    webviewVersion: deviceInfo.webViewVersion,
    nativeVersion: version.native,
    appVersion: version.name,
    appBuild: version.build
  }
}
